import React from "react";
import { motion } from "framer-motion";
// import logoImg from "../../../../src/Assets/Images/logo-container.svg";

import "./OurTechAndFrame.css";
import { Link } from "react-router-dom";

const OurTechAndFrame = () => {
  return (
    <section
      id="technologies"
      className="py-5 text-center"
      style={{ backgroundColor: "#0B152F", color: "#fff" }}
    >
      <div className="container">
        {/* Heading Section */}
        <h2 className="fw-semibold tech-pad-nav Tech-heading">
          The Tools Behind Confident Builds
        </h2>
        <p className="text-light technology__desc  mb-4">
          Behind every trustworthy product, there is a well-thought-out tech
          stack. We employ advanced and proven tech and frameworks that ensure
          the sustainability of your software applications as your business
          expands, no matter what the future may hold.
        </p>

        {/* Button */}
        <Link to="/technologies">
          <motion.button
            type="button"
            className="  px-5 py-3 rounded-pill mb-5"
            initial={{
              backgroundColor: "#19BDDE",
              boxShadow: "0 8px 30px rgba(25, 189, 222, 0.4)",
            }}
            whileHover={{
              backgroundColor: "#12869E",

              boxShadow: "none",
            }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            style={{
              border: "none",
              color: "#fff",
              fontSize: "2rem",
            }}
          >
            EXPLORE ALL
          </motion.button>
        </Link>

        {/* Logos Grid */}
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="d-flex  justify-content-center gap-3">
              <img
                src="https://res.cloudinary.com/davmkct9m/image/upload/v1769499435/logo-container_syvpxu.svg"
                alt="Technology logos"
                className=""
                style={{
                  width: "70%",
                  height: "auto",
                  padding: "0",
                  margin: "0",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurTechAndFrame;
